import t from '../../translation';

const armor = {
  0: {
    text: t('armorBase0Text'),
    notes: t('armorBase0Notes'),
    value: 0,
  },
};

const back = {
  0: {
    text: t('backBase0Text'),
    notes: t('backBase0Notes'),
    value: 0,
  },
};

const body = {
  0: {
    text: t('bodyBase0Text'),
    notes: t('bodyBase0Notes'),
    value: 0,
  },
};

const eyewear = {
  0: {
    text: t('eyewearBase0Text'),
    notes: t('eyewearBase0Notes'),
    value: 0,
    last: true,
  },
};

const head = {
  0: {
    text: t('headBase0Text'),
    notes: t('headBase0Notes'),
    value: 0,
  },
};

const headAccessory = {
  0: {
    text: t('headAccessoryBase0Text'),
    notes: t('headAccessoryBase0Notes'),
    value: 0,
    last: true,
  },
};

const shield = {
  0: {
    text: t('shieldBase0Text'),
    notes: t('shieldBase0Notes'),
    value: 0,
  },
};

const weapon = {
  0: {
    text: t('weaponBase0Text'),
    notes: t('weaponBase0Notes'),
    value: 0,
  },
};

export {
  armor,
  back,
  body,
  eyewear,
  head,
  headAccessory,
  shield,
  weapon,
};
